import axios from 'axios';

export default class Service {
    constructor() {
        this.axios = axios;
    }
}